/**
 * Query-key factory for the super-admin users console (RBAC FE WS-D).
 *
 * One source of truth for the SA-list cache key so the invite/revoke mutations
 * invalidate the exact query the console reads (invariant #7 — keep local state
 * consistent with the backend after every write).
 */

/** Cache key for the super-admin users list: `['admin', 'super-admins']`. */
export function saUsersKey() {
  return ["admin", "super-admins"] as const;
}
